module.exports = __webpack_public_path__ + "static/img/visionPic1.736cff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/visionPic1.jpg
// module id = Kz2z
// module chunks = 0